module.exports = __webpack_public_path__ + "img/goal-eighteen-br.20b5e4fa.png";